import React, { useState } from 'react';
import { Heart, Brain, Activity, Timer } from 'lucide-react';
import { HrvBreakdown } from '../hrv/HrvBreakdown';
import { HrvInsights } from '../hrv/HrvInsights';
import { HrvTrends } from '../hrv/HrvTrends';
import { HrvKnowledge } from '../hrv/HrvKnowledge';
import { HrvMetricCard } from '../hrv/HrvMetricCard';
import { HealthMetrics } from '../../types/health';

interface HrvTabProps {
  metrics: HealthMetrics;
  onClose: () => void;
}

export function HrvTab({ metrics, onClose }: HrvTabProps) {
  const [selectedTimeframe, setSelectedTimeframe] = useState<'24h' | '7d' | '30d'>('24h');

  return (
    <div className="space-y-6">
      {/* HRV Metrics Overview */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <HrvMetricCard
          title="Current HRV"
          value={metrics.hrv.current}
          unit="ms"
          icon={<Heart className="w-4 h-4" />}
          status={metrics.hrv.current > metrics.hrv.yesterday ? 'success' : 'warning'}
          comparison={`${metrics.hrv.current - metrics.hrv.yesterday}ms vs yesterday`}
        />
        <HrvMetricCard
          title="Recovery"
          value={metrics.recovery}
          unit="%"
          icon={<Activity className="w-4 h-4" />}
          status={metrics.recovery > 70 ? 'success' : 'warning'}
          comparison={`${metrics.recovery - 65}% vs baseline`}
        />
        <HrvMetricCard
          title="Resting HR"
          value={62}
          unit="bpm"
          icon={<Timer className="w-4 h-4" />}
          status="success"
          comparison="-2 bpm vs baseline"
        />
        <HrvMetricCard
          title="Stress Level"
          value={metrics.stress.current}
          unit="%"
          icon={<Brain className="w-4 h-4" />}
          status={metrics.stress.current < 50 ? 'success' : 'warning'}
          comparison={`${metrics.stress.current - metrics.stress.yesterday}% vs yesterday`}
        />
      </div>

      {/* HRV Score Trends */}
      <HrvTrends 
        metrics={metrics}
        timeframe={selectedTimeframe}
        onTimeframeChange={setSelectedTimeframe}
      />

      {/* HRV Breakdown */}
      <HrvBreakdown metrics={metrics} />

      {/* ML-Powered Insights */}
      <HrvInsights metrics={metrics} />

      {/* Knowledge Center */}
      <HrvKnowledge />
    </div>
  );
}